import { render, staticRenderFns } from "./ChatMessageInput.vue?vue&type=template&id=6715528b&scoped=true"
import script from "./ChatMessageInput.vue?vue&type=script&lang=js"
export * from "./ChatMessageInput.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageInput.vue?vue&type=style&index=0&id=6715528b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6715528b",
  null
  
)

export default component.exports